// Llamadas al backend del panel de precios vs competencia. Devuelven `data` o rechazan con
// `{ code, message }`; el 7501 (funcionalidad apagada) lo decide quien llama.

var config = process.env;

export const FEATURE_OFF = 7501;
export const BADGE_EVENT = 'competitorPricesBadgeChanged';

export function competitorPricesApi(method, path = '', body) {
    const request = {
        method,
        headers: {
            'access-token': localStorage.getItem('token'),
            'Content-Type': 'application/json'
        }
    };
    if (body !== undefined) {
        request.body = JSON.stringify(body);
    }
    return fetch(`${config.REACT_APP_BASE_URL}${config.REACT_APP_VERSION}competitor-prices${path}`, request)
        .then(res => res.json())
        .then(data => {
            if (data.error > 0) {
                if (data.error === 1002) {
                    window.location.href = localStorage.getItem('homePageURL');
                }
                return Promise.reject({ code: data.error, message: data.message });
            }
            return data.data;
        });
}

/** Avisa al menú que el contador de avisos pudo haber cambiado. */
export function notifyBadgeChanged() {
    try {
        sessionStorage.removeItem('competitorPricesBadge');
    } catch (error) { /* sin sessionStorage el menú vuelve a pedirlo igual */ }
    window.dispatchEvent(new Event(BADGE_EVENT));
}
